import type { IProductsWithDifferentRegionResponse } from '@/services/OrderService/interfaces'

const isProductsWithDifferentRegion = (response: unknown): response is IProductsWithDifferentRegionResponse => {
  const productWithDifferentRegion = (response as IProductsWithDifferentRegionResponse)?.items?.[0]

  return Boolean(productWithDifferentRegion?.productOfferId && productWithDifferentRegion?.skuName)
}

export default isProductsWithDifferentRegion
